import partsCategories from '../partsCategories';
import SelectedParts from '../types/SelectedParts';

export default (): SelectedParts => {
  const randomSelectedParts: SelectedParts = {};

  partsCategories.forEach((category) => {
    randomSelectedParts[category.name] =
      category.children[Math.floor(Math.random() * category.children.length)];
  });

  return randomSelectedParts;
};
